import { Component, Input, OnInit } from '@angular/core';
import { isEmptyObject } from '../../../shared/util/object-util';

@Component({
    selector: 'app-expandable-json-viewer',
    templateUrl: './expandable-json-viewer.component.html',
    styleUrls: ['./expandable-json-viewer.component.css']
})
export class ExpandableJsonViewerComponent implements OnInit {

  @Input() json: any;
  showJson: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  show(): void {
      this.showJson = true;
  }

  hide(): void {
      this.showJson = false;
  }

  protected readonly isEmptyObject = isEmptyObject;
}
